import { IconError } from "@/Icons/Error";
import { Translate, useTrans } from "@/translations";

export const OutstandingPaymentsBanner: React.FC = () => {
  const { t } = useTrans();
  return (
    <div className="my-2 h-full w-full py-3 pr-5">
      <div className="border-carrot-red bg-light-peach relative flex h-full w-full items-center border-2">
        <div className="top-5 pl-3">
          <IconError />
        </div>
        <div className="pr-3 pl-5">
          <div className="text-tomato text-xs leading-4 xl:text-sm">
            <b>{t("errors:hasOutstandingPaymentsTitle")}</b>{" "}
            <Translate
              i18nKey="errors:hasOutstandingPaymentsInstructions"
              components={[
                // Anchor content is added by the translation
                // eslint-disable-next-line jsx-a11y/anchor-has-content
                <a
                  href="mailto:accounting@carrot.tech"
                  className="text-tomato font-bold underline"
                />,
              ]}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
